import * as React from "react"

import { NoseLong } from "./long"
import { NoseShort } from "./short"
import { NoseRound } from "./round"

const _Nose = ({ style, isEditor }: { style: string; isEditor?: boolean }) => {
  switch (style) {
    case "long":
      return <NoseLong isEditor={isEditor} />
    case "round":
      return <NoseRound isEditor={isEditor} />
    case "short":
    default:
      return <NoseShort isEditor={isEditor} />
  }
}

export const Nose = React.memo(_Nose)
